import React, { useState } from "react";
import { logo, profileimg } from "../../assets/images";
import MenuIcon from "@mui/icons-material/Menu";
import GridViewIcon from "@mui/icons-material/GridView";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import CategoryIcon from "@mui/icons-material/Category";
import LogoutIcon from "@mui/icons-material/Logout";
import DvrIcon from "@mui/icons-material/Dvr";
import { useLocation, useNavigate } from "react-router-dom";
import LogoutPopup from "../LogoutPopup";
import { useLogoutMutation } from "../../constants/redux/api/api";

const Navber = ({ menuOpen, toggle }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location?.pathname;
  const [logoutPopupShow, setLogoutPopupShow] = useState(false);
  const [logout] = useLogoutMutation();
  // console.log(pathname);

  const toggleLogoutPopup = () => {
    setLogoutPopupShow(!logoutPopupShow);
  };

  const confirmLogout = () => {
    console.log("confirmLogout");
    logout()
      .unwrap()
      .then((res) => {
        if (res?.status === "success") {
          console.log(res);
          navigate("/");
          localStorage.clear();
        }
      });
  };

  return (
    <div className="view_pad">
      <header className="header-admin user_head">
        <div
          className={`${menuOpen && "logo-toggle"} d-flex align-items-center`}
          style={{ transition: "0.3s" }}
        >
          <button
            className="header_toggle bg-transparent border-0"
            onClick={toggle}
          >
            {!menuOpen ? (
              <MenuIcon className="menu_icon fs-3" />
            ) : (
              <CloseOutlinedIcon CloseOutlinedIcon className="menu_icon fs-3" />
            )}
          </button>
          <div className="nav_logo">
            <img src={logo} alt="" />
          </div>
        </div>
        <div className="header_img align-selfe-end">
          <img src={profileimg} alt="profile" />
        </div>
      </header>
      <div className={menuOpen ? "show l-navbar" : "l-navbar"}>
        <nav className="nav user-side-nav">
          <div>
            <div className="nav_list">
              <p
                className={`nav_link ${
                  pathname === "/table-list" ? "active" : ""
                }`}
                onClick={() => {
                  toggle();
                  navigate("/table-list");
                }}
              >
                <GridViewIcon
                  className={`fs-5' ${
                    pathname === "/table-list" ? "active" : "primary1"
                  } `}
                />
                <span className="nav_name">Table List</span>
              </p>

              <p
                className={`nav_link ${pathname === "/" ? "active" : ""}`}
                onClick={() => {
                  toggle();
                  navigate("/admin-menu");
                }}
              >
                <MenuBookIcon
                  className={`fs-5' ${
                    pathname === "/" ? "active" : "primary1"
                  } `}
                />
                <span className="nav_name">Menu</span>
              </p>

              <p
                className={`nav_link ${
                  pathname === "/category-list" ? "active" : ""
                }`}
                onClick={() => {
                  toggle();
                  navigate("/category-list");
                }}
              >
                <CategoryIcon
                  className={`fs-5' ${
                    pathname === "/category-list" ? "active" : "primary1"
                  } `}
                />
                <span className="nav_name">Category List</span>
              </p>

              <p
                className={`nav_link ${
                  pathname === "/order-list" ? "active" : ""
                }`}
                onClick={() => {
                  toggle();
                  navigate("/order-list");
                }}
              >
                <DvrIcon
                  className={`fs-5' ${
                    pathname === "/order-list" ? "active" : "primary1"
                  } `}
                />
                <span className="nav_name">Order List</span>
              </p>

              <p
                className="nav_link  "
                onClick={() => {
                  toggle();
                  navigate("/order-list");
                }}
              >
                <AccountBoxIcon className="primary1 fs-5" />
                <span className="nav_name">Order History</span>
              </p>

              <p
                className="nav_link  "
                onClick={() => {
                  toggle();
                  navigate("/robots-list");
                }}
              >
                <AccountBoxIcon className="primary1 fs-5" />
                <span className="nav_name">Robots List</span>
              </p>

              {/* <p className="nav_link  ">
                <HelpOutlineIcon className="primary1 fs-5" />
                <span className="nav_name">Help &amp; Support</span>
              </p> */}
            </div>
          </div>
          <p onClick={toggleLogoutPopup} className="nav_link">
            <LogoutIcon className="primary1 fs-5" />
            <span className="nav_name">SignOut</span>{" "}
          </p>
        </nav>
      </div>
      {logoutPopupShow && (
        <LogoutPopup
          onCancelClick={toggleLogoutPopup}
          onConfirmClick={confirmLogout}
        />
      )}
    </div>
  );
};

export default Navber;
